import { render, staticRenderFns } from "./ShipmentsList.vue?vue&type=template&id=353f0a22&scoped=true&"
import script from "./ShipmentsList.vue?vue&type=script&lang=js&"
export * from "./ShipmentsList.vue?vue&type=script&lang=js&"
import style0 from "./ShipmentsList.vue?vue&type=style&index=0&id=353f0a22&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "353f0a22",
  null
  
)

export default component.exports